"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DoubtType;
(function (DoubtType) {
    DoubtType["NEED_SORTING_COLUMN"] = "need_sorting_column";
    DoubtType["NEED_DATE_COLUMN"] = "need_date_column";
    DoubtType["IS_IT_NEW_QUERY"] = "is_it_new_query";
    DoubtType["AMBIGUITY"] = "ambiguity";
    DoubtType["IGNORED"] = "ignored";
})(DoubtType || (DoubtType = {}));
exports.default = DoubtType;
//# sourceMappingURL=DoubtType.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/DoubtType.js
// module id = 826
// module chunks = 8